export const MuiLinkOverride = {
  styleOverrides: {
    root: {
      textDecoration: 'none',
      color: '#2222B3',
      fontFamily: 'Inter',
    },
  },
};
